import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Loading } from "@/components/ui/loader";
import { useRecipeStockSettings } from "../hooks/useRecipeStockSettings";

export function RecipeStockSettingsFields({
	model,
	disabled,
}: {
	model: ReturnType<typeof useRecipeStockSettings>;
	disabled: boolean;
}) {
	const { t } = useTranslation();
	return (
		<section
			id="recipe-stock-settings"
			aria-labelledby="recipe-stock-settings-title"
			className="space-y-4 border-t pt-5"
		>
			<div>
				<h3 id="recipe-stock-settings-title" className="text-base font-semibold">
					{t("settings.recipe.title")}
				</h3>
				<p className="text-sm text-muted-foreground">{t("settings.recipe.sharedScope")}</p>
			</div>
			{model.loading ? (
				<Loading />
			) : model.error ? (
				<div role="alert" className="space-y-2">
					<p>{t("settings.recipe.loadFailed")}</p>
					<Button variant="outline" onClick={model.retry}>
						{t("common.retry")}
					</Button>
				</div>
			) : (
				(["blockSaleWhenInsufficientStock", "allowNegativeStock"] as const).map(key => (
					<div key={key} className="flex items-center justify-between gap-4">
						<div>
							<Label htmlFor={`recipe-policy-${key}`}>{t(`settings.recipe.${key}`)}</Label>
							<p className="text-sm text-muted-foreground">{t(`settings.recipe.${key}Description`)}</p>
						</div>
						<Switch
							id={`recipe-policy-${key}`}
							aria-label={t(`settings.recipe.${key}`)}
							disabled={disabled}
							checked={model.draft[key]}
							onCheckedChange={checked => model.setDraft(previous => ({ ...previous, [key]: checked }))}
						/>
					</div>
				))
			)}
		</section>
	);
}
